import React from "react";


export const InfoCard = ({ text, className }) => {
  return (
    <div className={`px-4 py-8 leading-6 shadow-2xl bg-slate-200 rounded-[30px] text-cyan-950 ${className}`}>
      {text}
    </div>
  );
};

export const ImageCard = ({ imageSrc, iconSrc, altText, iconAltText }) => {
  return (
    <div className="flex overflow-hidden relative flex-col items-end px-9 pt-28 pb-2.5 aspect-[1.166] shadow-[var(--sds-size-depth-0)_var(--sds-size-depth-400)_var(--sds-size-depth-800)_var(--sds-size-depth-negative-200)_var(--sds-color-black-400)] w-[473px]">
      <img
        loading="lazy"
        src={imageSrc}
        alt={altText}
        className="object-cover absolute inset-0 size-full"
      />
      <img
        loading="lazy"
        src={iconSrc}
        alt={iconAltText}
        className="object-contain aspect-square w-[27px]"
      />
    </div>
  );
};


export default function KarmaSection() {
  const infoCards = [
    {
      text: "Ganhe karma ao se voluntariar ou doar para projetos sociais.",
      className: "text-lg font-semibold"
    },
    {
      text: "O karma é nossa moeda social, criada para promover uma economia sustentável e solidária.",
      className: "text-sm font-medium"
    },
    {
      text: "Acumule karmas e troque por produtos e experiências oferecidos por marcas parceiras.",
      className: "text-sm font-medium"
    }
  ];


  return (
    <>
    <section className="self-center mt-32 md:w-3/4 w-11/12 max-md:mt-10 max-md:max-w-full hidden sm:block">
      <div className="flex gap-5 max-md:flex-col">
      <article className="flex flex-col w-[37%] max-md:ml-0 max-md:w-full z-20">
        <div className="flex flex-col justify-center self-stretch p-10 my-auto w-full text-lg bg-[#e6f2f9] rounded-[40px] max-md:px-5 max-md:mt-10">
          <h2 className="font-bold text-cyan-950">
            Ganhe karma ao se voluntariar ou doar para projetos sociais.
          </h2>
          <p className="mt-2.5 text-stone-900">
            O karma é nossa moeda social, criada para promover uma economia
            sustentável e solidária. Acumule karmas e troque por produtos e
            experiências oferecidos por marcas parceiras.
          </p>
        </div>
      </article>
      <article className="flex flex-col ml-5 md:w-[63%] max-md:ml-0 max-md:w-full z-10 w-11/12">
      <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/103790acd32d40c0b511bf41726fd638/49822889f5e8c0882618bdeb5852c1e99c4ef7d82d21fd2a72822eff919548dd?apiKey=103790acd32d40c0b511bf41726fd638&"
        alt="Karma rewards illustration"
        className="object-contain grow w-full aspect-[1.35] max-md:mt-10 max-md:max-w-full drop-shadow-[0px_12px_12px_rgba(0,0,0,0.4)]"
      />
    </article>
    </div>
    </section>
  <section className="self-center mt-32 md:w-3/4 w-11/12 max-md:mt-10 max-md:max-w-full sm:hidden ">
    <h1 className="z-10 self-start -mt-1 ml-3.5 text-2xl font-medium leading-7 text-cyan-950">
      Somos a plataforma que transforma suas{" "}
      <span className="font-bold">boas ações</span> em{" "}
      <span className="font-bold">recompensas</span>.
    </h1>
    <div className="flex gap-3.5 mt-7">
      <ImageCard
        imageSrc="https://cdn.builder.io/api/v1/image/assets/TEMP/600860a8f13d2c47b52fe0a6ad7a36911a6da69c0776c30177ee21b4d967cb36?placeholderIfAbsent=true&apiKey=103790acd32d40c0b511bf41726fd638"
        iconSrc="https://cdn.builder.io/api/v1/image/assets/TEMP/3d9e65875f9aa5ed5afff893c973f63846d44e957bada472a0bf0ec67e228cf2?placeholderIfAbsent=true&apiKey=103790acd32d40c0b511bf41726fd638"
        altText="Social platform illustration"
        iconAltText="Platform icon"
      />
      <InfoCard text={infoCards[0].text} className={infoCards[0].className} />
    </div>
    <div className="flex gap-3.5 mt-6">
      <InfoCard text={infoCards[1].text} className={infoCards[1].className} />
      <ImageCard
        imageSrc="https://cdn.builder.io/api/v1/image/assets/TEMP/648ff0eaa41cac9ac134f2f7f47f75b0ea029b5c3dd537a9b3497f61e65ddd90?placeholderIfAbsent=true&apiKey=103790acd32d40c0b511bf41726fd638"
        iconSrc="https://cdn.builder.io/api/v1/image/assets/TEMP/569987100f69c6258f67e1d26d555be302b9ff0648f62b250793d7076ec13d55?placeholderIfAbsent=true&apiKey=103790acd32d40c0b511bf41726fd638"
        altText="Social economy illustration"
        iconAltText="Economy icon"
      />
    </div>
    <div className="flex gap-4 mt-6 text-sm font-medium leading-5 text-cyan-950">
      <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/7dcb2906460d8d81727ab402ba269c71cd4b7a9aad9033abb633c9b2fb607195?placeholderIfAbsent=true&apiKey=103790acd32d40c0b511bf41726fd638"
        alt="Rewards illustration"
        className="object-contain shrink-0 w-44 max-w-full aspect-[1.17] shadow-[var(--sds-size-depth-0)_var(--sds-size-depth-400)_var(--sds-size-depth-800)_var(--sds-size-depth-negative-200)_var(--sds-color-black-400)]"
      />
      <InfoCard text={infoCards[2].text} className={infoCards[2].className} />
    </div>
  </section>
    </>
  );
}
